import { MapPin } from "lucide-react";
import { useSEO, buildBreadcrumbsJsonLd } from "../lib/seo";
import { useSiteTexts } from "../lib/siteTexts";
import { useSiteMedia } from "../lib/siteMedia";
import { COMPANY, SITE_URL } from "../lib/constants";
import { PAGE_TEXTS } from "../data/pageTexts";
import { ABOUT_NAV, ABOUT_POINTS } from "../data/about";
import { InfoHero } from "../components/info/InfoHero";
import { InfoSection } from "../components/info/InfoSections";
import { AdviceEndCta } from "../components/info/AdviceBlocks";
import { ProductSubnav } from "../components/product/ProductSubnav";
import { HomeReviews } from "../components/home/HomeReviews";
import { AboutActivities, AboutCraft, AboutPrinciples, AboutWho } from "../components/about/AboutSections";
import { AboutSystems } from "../components/about/AboutSystems";
import { AboutArea } from "../components/about/AboutArea";

const cfg = PAGE_TEXTS.overons;

const aboutLd = (seo, image) => ({
  "@context": "https://schema.org", "@type": "AboutPage", name: seo.title, description: seo.body, url: SITE_URL + cfg.path, inLanguage: "nl-NL", image,
  mainEntity: { "@type": "HomeAndConstructionBusiness", "@id": `${SITE_URL}/#localbusiness`, name: COMPANY.name, founder: { "@type": "Person", name: "Hilmi Yildirimer" },
    areaServed: { "@type": "AdministrativeArea", name: COMPANY.region }, telephone: COMPANY.phone, email: COMPANY.email },
});

export default function OverOns() {
  const t = useSiteTexts("overons");
  const media = useSiteMedia();
  const seo = t(cfg.blocks.seo);
  const [who, craft, area] = [t(cfg.blocks.wie), t(cfg.blocks.vakmanschap), t(cfg.blocks.werkgebied)];
  const crumbs = [{ label: "Home", href: "/" }, { label: "Over ons", href: cfg.path }];
  const hero = media("ov_hero");
  const image = hero.src.startsWith("/") ? SITE_URL + hero.src : hero.src;
  useSEO({ title: seo.title, description: seo.body, path: cfg.path, ogImage: image, jsonLd: aboutLd(seo, image), breadcrumbs: buildBreadcrumbsJsonLd(crumbs) });

  return (
    <div data-testid="about-page">
      <InfoHero crumbs={crumbs} eyebrow="Over Maas Kozijn" block={t(cfg.blocks.hero)} points={ABOUT_POINTS} mediaKey="ov_hero" location="over-ons"
        badge={{ icon: MapPin, title: "Gevestigd in Maassluis", text: "Actief in heel Zuid-Holland" }} />
      <ProductSubnav items={ABOUT_NAV} />
      <InfoSection id="wie-wij-zijn" eyebrow="Wie wij zijn" title={who.title}><AboutWho block={who} /></InfoSection>
      <InfoSection id="wat-wij-doen" tone="slate" eyebrow="Wat wij doen" title="Complete kozijnen, van inmeten tot afwerking"
        lead="Afhankelijk van de opdracht verzorgen wij het hele traject, zodat u met één partij te maken heeft.">
        <AboutActivities />
      </InfoSection>
      <InfoSection id="kwaliteit" eyebrow="Materialen" title="Kwaliteitsprofielen voor kunststof en aluminium"
        lead="Wij noemen alleen merken en systemen waarmee wij daadwerkelijk werken.">
        <AboutSystems />
      </InfoSection>
      <InfoSection id="vakmanschap" tone="slate" eyebrow="Vakmanschap" title={craft.title}><AboutCraft block={craft} /></InfoSection>
      <InfoSection id="uitgangspunten" eyebrow="Onze uitgangspunten" title="Waar u bij Maas Kozijn op kunt rekenen"><AboutPrinciples /></InfoSection>
      <HomeReviews />
      <InfoSection id="werkgebied" tone="slate" eyebrow="Werkgebied" title={area.title}><AboutArea block={area} /></InfoSection>
      <AdviceEndCta title="Benieuwd wat nieuwe kozijnen voor uw woning kosten?" location="over-ons" />
    </div>
  );
}
